// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { PluginModel } from 'types';

export const isPluginHidden = (plugin: PluginModel) => {
  return (
    plugin.moderatedState === 'hidden' || plugin.moderatedState === 'moderated'
  );
};

export const getPlugins = (state: State): PluginModel[] => {
  return state.models.plugins.filter((plugin) => {
    return !isPluginHidden(plugin);
  });
};

export const getPluginsByCategory = (
  state: State,
  category: string,
): PluginModel[] => {
  return state.models.plugins.filter((plugin) => {
    return !isPluginHidden(plugin) && plugin.categories.includes(category);
  });
};

export const getPluginById = (
  state: State,
  id: string,
): PluginModel | undefined => {
  return state.models.plugins.find((plugin) => {
    return !isPluginHidden(plugin) && plugin.id === id;
  });
};

export const getPluginsByTags = (
  state: State,
  tags: string[],
): PluginModel[] => {
  return state.models.plugins.filter((plugin) => {
    if (plugin.tags.length === 0) {
      return false;
    } else {
      return tags.every((tag) => {
        return plugin.tags.includes(tag);
      });
    }
  });
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/plugins.ts